// extracted by mini-css-extract-plugin
module.exports = {"moviesPanel":"MoviesView_moviesPanel__cRmPh","filterButtonWrapper":"MoviesView_filterButtonWrapper__Zy3d4","filtersButton":"MoviesView_filtersButton__0qkC0"};